// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-width-setting__container {
  display: flex;
  align-items: center;
}
.column-width-setting__input {
  width: 80px;
  margin-left: 8px;
}
.column-width-setting__input .g-text-input {
  position: static;
}
.column-width-setting__input .g-text-input__error {
  margin-left: -15px;
  width: 120px;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogColumnSettings/components/ColumnWidthSetting/ColumnWidthSetting.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;AAAR;AAGI;EACI,WAAA;EACA,gBAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAGY;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;AADhB","sourcesContent":[".column-width-setting__container {\n  display: flex;\n  align-items: center;\n}\n.column-width-setting__input {\n  width: 80px;\n  margin-left: 8px;\n}\n.column-width-setting__input .g-text-input {\n  position: static;\n}\n.column-width-setting__input .g-text-input__error {\n  margin-left: -15px;\n  width: 120px;\n  position: absolute;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
